import { dispatch, useReframe } from 'nike-re-framejs';
import { loggedIn$ } from '../../../subs';
import { useContext, useEffect } from 'react';
import { loadActiveTickets } from '../handlers';
import TurboLiveContext from '../../../context/TurboLiveContext';
import { nuiCtx } from '../../../../../common/initialization';

export const useLoadActiveTickets = () => {
    const { derefSub } = useReframe();
    const loggedIn = derefSub(loggedIn$);
    const { getActiveTickets } = useContext(TurboLiveContext);

    useEffect(() => {
        if (!loggedIn) {
            return () => {};
        }
        const loadTickets = () => getActiveTickets().then(json => dispatch(loadActiveTickets(json)));
        const pushSubscription = nuiCtx.pushClient.subscription({
            onMessage() {
                loadTickets();
            }
        });
        pushSubscription.resetPushPaths(['/user-ticket-index/current/']);
        loadTickets();
        return () => pushSubscription.close();
    }, [loggedIn, getActiveTickets]);
};
